import { colors } from './colors';
import { fonts } from './fonts';
import { ThemeConfig } from './interface';

const themeConfig: ThemeConfig = {
  light: {
    fontConfig: fonts,
    avatarColors: [
      '#C8FAF9',
      '#E8D6FE',
      '#FEE2BE',
      '#E5F9B3',
      '#CDFAE4',
      '#F9D5FE',
      '#BEEBFC',
      '#FFDAEE',
      '#FDF7BC',
      '#DDDEFF',
      '#FFE1D9',
      '#E5EFFF',
    ],
    nameColors: [
      '#00A7FF',
      '#9A3CFF',
      '#FF9500',
      '#4CC300',
      '#00C7A3',
      '#E62CFF',
      '#008CFF',
      '#FF4FB7',
      '#E6C400',
      '#4A5CFF',
      '#FF6236',
      '#3B80FF',
    ],
    borderColors: [
      '#33CFF9',
      '#B16DFF',
      '#FFAC33',
      '#77D626',
      '#29D4B4',
      '#E86AFF',
      '#33A7FF',
      '#FF7DCB',
      '#EDD332',
      '#7880FF',
      '#FF845F',
      '#5A9CFF',
    ],
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
      highlight: colors.textHighlight,
    },
    chat: {
      message: {
        background: {
          sender: colors.senderMsgBubble,
          receiver: colors.white,
          failure: colors.msgFailure,
          internalNote: colors.bisque,
        },
      },
      reply: {
        background: {
          sender: colors.ceruleanSecondary,
          receiver: colors.white,
        },
      },
      dateSeparator: colors.lavenderGray,
      header: colors.white,
      input: {
        container: colors.white,
        background: colors.msgInputBg,
        internalNote: colors.cosmicLatte,
      },
      unreadCount: { background: colors.gray90Opacity, text: colors.white },
    },
  },
};

export const theme = themeConfig.light;
